import { NotifyHelper } from "../../../helpers/toast";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import { generateActionForKey, generateActions } from "../generateActions";
import { rootActions } from "../rootActions";
import { eChuongTrinhDaoTaoActionsObj } from './../../action-types/ctdt/IChuongTrinhDaoTaoActionTypes';

export const chuongTrinhDaoTaoActions = {
    ...generateActions(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO"),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "SAVE_ERROR", (m) => NotifyHelper.Error(m)
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "DELETE_ERROR", (m) => NotifyHelper.Error(m)
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "COPY_ERROR", (m) => NotifyHelper.Error(m)
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "COPY_SUCCESS", () => NotifyHelper.Success("Thành công")
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "PASTE_CLIPBOARD_DATA_ERROR", (m) => NotifyHelper.Error(m)
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "PASTE_CLIPBOARD_DATA_SUCCESS", () => {
             NotifyHelper.Success("Sao chép thành công"); 
        }
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "UPDATE_TOTAL_TIN_CHI_ERROR", (m) => NotifyHelper.Error(m)
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "UPDATE_TOTAL_TIN_CHI_SUCCESS", () => NotifyHelper.Success("Thành công")
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "UPDATE_LOCK_STATUS_ERROR", (m) => NotifyHelper.Error(m)
    ),
    ...generateActionForKey(eChuongTrinhDaoTaoActionsObj, "CHUONG_TRINH_DAO_TAO",
        "UPDATE_LOCK_STATUS_SUCCESS", () => NotifyHelper.Success("Thành công")
    ),
}